<template>
  <Visitor>
    <main class="">
      <div class="max-w-4xl mx-auto py-8 sm:px-6 lg:px-8 text-center">
        <div class="bg-white rounded-lg shadow px-5 py-6 sm:px-6 mx-2">
          <h2
            class="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl"
          >
            Trabaja con
            <br class="xl:hidden" />
            <span class="text-primary-600">nosotros </span>
          </h2>
          <p
            class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-8 md:text-xl"
          >
            Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui
            lorem cupidatat commodo. Elit sunt amet fugiat veniam occaecat
            fugiat aliqua.
          </p>
          <div class="mt-5 sm:mt-8 px-4 sm:flex sm:justify-center">
            <router-link to="/signup/indie">
              <div
                class="transition ease-in-out duration-150 border-gray-300 border-dashed border-4 hover:border-solid hover:border-primary-400 hover:bg-gray-100 cursor-pointer overflow-hidden rounded-lg"
              >
                <div class="px-4 py-5 sm:p-6">
                  <IconSvg
                    :solid="true"
                    icon="user"
                    myClass="h-12 w-12 mx-auto mb-2 text-gray-800"
                  />
                  Trabajador Independiente
                </div>
              </div>
            </router-link>
            <div
              class="transition ease-in-out duration-150 border-gray-300 border-dashed border-4 hover:border-solid hover:border-primary-400 hover:bg-gray-100 cursor-pointer overflow-hidden rounded-lg sm:ml-8 mt-4 sm:mt-0"
            >
              <div class="px-4 py-5 sm:p-6 w-48 text-center mx-auto">
                <IconSvg
                  :solid="true"
                  icon="office-building"
                  myClass="h-12 w-12 mx-auto mb-2 text-gray-800"
                />
                Empresa
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </Visitor>
</template>

<script>
import IconSvg from "../components/IconSvg";
import Visitor from "./Layouts/Visitor";

export default {
  name: "JoinUs",
  components: {
    IconSvg,
    Visitor
  }
};
</script>